import * as React from "react";
import IconButton from "../common/Button/IconButton";
import Alert from "../common/Alert";
import log from "@app/util/log";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, info) {
		log.error(error, { componentStack: info.componentStack });

		if (this.props.onError) {
			this.props.onError(error, info);
		}
	}

	render() {
		if (this.state.hasError) {
			if (this.props.fallback) {
				if (typeof this.props.fallback === "function") {
					return this.props.fallback(this.state.error);
				}
				return this.props.fallback;
			}

			return (
				<div className="flex flex-col min-h-screen items-center justify-center p-4">
					<Alert type="error" className="mb-4 flex flex-col gap-4">
						<div className="text-xl">
							An unexpected error occurred.
						</div>
						<div className="flex justify-center gap-4">
							<p className="mb-4 text-sm">
								Please try refreshing the page.
							</p>
							<IconButton
								icon={"refresh"}
								onClick={() => window.location.reload()}
								title="Reload page"
							></IconButton>
						</div>
					</Alert>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
